import { combineEpics } from 'redux-observable';

import * as bookDirectEpics from '../features/bookDirect/epics';
import * as bookMultiEpics from '../features/bookMulti/epics';
import * as addressesEpics from '../features/addresses/epics';
import * as ordersEpics from '../features/orders/epics';

export default combineEpics(
  ...Object.values(bookDirectEpics),
  ...Object.values(bookMultiEpics),
  ...Object.values(addressesEpics),
  ...Object.values(ordersEpics)
);
